<script>
	import bulmaCollapsible from '@creativebulma/bulma-collapsible';

	export default {
		props: {
			sorts: Array,
			categories: Array,
			regions: Array,
			days: Array,
			filterSorts: Array,
			filterCategories: Array,
			filterRegions: Array,
			filterDays: Array,
			sortsLabel: String,
			categoriesLabel: String,
			regionsLabel: String,
			daysLabel: String,
		},
		methods: {
			toggleSort(sortName) {
				this.$emit('filter-sort', sortName);
			},
			toggleCategory(categoryName) {
				this.$emit('filter-category', categoryName);
			},
			toggleRegion(regionName) {
				this.$emit('filter-region', regionName);
			},
			toggleDay(dayName) {
				this.$emit('filter-day', dayName);
			},
		},
		updated() {
			if (!this.$refs.filter) return;
			this.$refs.filter.forEach($collapsible => {
				if (window.getComputedStyle($collapsible).height != '0px') bulmaCollapsible.attach($collapsible);
			});
		},
	};
</script>

<template>
	<div class="filtering">
		<template v-if="sorts.length">
			<div class="field mb-5">
				<h2 class="title is-5 has-text-text mb-3">{{ sortsLabel }}</h2>
				<template v-for="sort in sorts" :key="sort.Id">
					<div class="control mb-2 is-flex is-align-items-center">
						<input name="checkbox"
							   type="checkbox"
							   class="by-checkbox"
							   :id="'sort-' + sort.Id"
							   :value="sort.Naam"
							   :checked="filterSorts.includes(sort.Naam)"
							   @change="toggleSort(sort.Naam)" />
						<label :for="'sort-' + sort.Id" class="by-checkable">{{ sort.Naam }}</label>
						<a v-if="sort.SubSoorten.length"
						   :href="`#collapse-${sort.Id}`"
						   data-action="collapse"
						   class="collapse-trigger is-borderless is-hoverless ml-auto p-0">
							<span class="icon is-rounded"><i class="fa-solid fa-plus"></i></span>
						</a>
					</div>
					<div v-if="sort.SubSoorten.length"
						 class="is-collapsible"
						 :id="`collapse-${sort.Id}`"
						 ref="filter">
						<template v-for="subsort in sort.SubSoorten" :key="subsort.Id">
							<div class="control mb-2 ml-4">
								<input name="checkbox"
									   type="checkbox"
									   class="by-checkbox"
									   :id="'subsort-' + subsort.Id"
									   :value="subsort.Naam"
									   :checked="filterSorts.includes(subsort.Naam)"
									   @change="toggleSort(subsort.Naam)" />
								<label :for="'subsort-' + subsort.Id" class="by-checkable">{{ subsort.Naam }}</label>
							</div>
						</template>
					</div>
				</template>
			</div>
			<hr class="has-background-secondary" />
		</template>

		<template v-if="categories.length">
			<div class="field mb-5">
				<h2 class="title is-5 has-text-text mb-3">{{ categoriesLabel }}</h2>
				<template v-for="category in categories" :key="category.Id">
					<div class="control mb-2 is-flex is-align-items-center">
						<input name="checkbox"
							   type="checkbox"
							   class="by-checkbox"
							   :id="'category-' + category.Id"
							   :value="category.Naam"
							   :checked="filterCategories.includes(category.Naam)"
							   @change="toggleCategory(category.Naam)" />
						<label :for="'category-' + category.Id" class="by-checkable">{{ category.Naam }}</label>
						<a v-if="category.SubCategorieen.length"
						   :href="`#collapse-${category.Id}`"
						   data-action="collapse"
						   class="collapse-trigger is-borderless is-hoverless ml-auto p-0">
							<span class="icon is-rounded"><i class="fa-solid fa-plus"></i></span>
						</a>
					</div>
					<div v-if="category.SubCategorieen.length"
						 class="is-collapsible"
						 :id="`collapse-${category.Id}`"
						 ref="filter">
						<template v-for="subcategory in category.SubCategorieen" :key="subcategory.Id">
							<div class="control mb-2 ml-4">
								<input name="checkbox"
									   type="checkbox"
									   class="by-checkbox"
									   :id="'subcategory-' + subcategory.Id"
									   :value="subcategory.Naam"
									   :checked="filterCategories.includes(subcategory.Naam)"
									   @change="toggleCategory(subcategory.Naam)" />
								<label :for="'subcategory-' + subcategory.Id" class="by-checkable">{{ subcategory.Naam }}</label>
							</div>
						</template>
					</div>
				</template>
			</div>
			<hr class="has-background-secondary" />
		</template>

		<template v-if="regions.length">
			<div class="field mb-5">
				<h2 class="title is-5 has-text-text mb-3">{{ regionsLabel }}</h2>
				<div v-for="region in regions" :key="region.Id" class="control mb-2">
					<input name="checkbox"
						   type="checkbox"
						   class="by-checkbox"
						   :id="'region-' + region.Id"
						   :value="region.Naam"
						   :checked="filterRegions.includes(region.Naam)"
						   @change="toggleRegion(region.Naam)" />
					<label :for="'region-' + region.Id" class="by-checkable">{{ region.Naam }}</label>
				</div>
			</div>
			<hr class="has-background-secondary" />
		</template>

		<template v-if="days.length">
			<div class="field">
				<h2 class="title is-5 has-text-text mb-3">{{ daysLabel }}</h2>
				<div v-for="day in days" :key="day.Id" class="control mb-2">
					<input name="checkbox"
						   type="checkbox"
						   class="by-checkbox"
						   :id="'day-' + day.Id"
						   :value="day.Naam"
						   :checked="filterDays.includes(day.Naam)"
						   @change="toggleDay(day.Naam)" />
					<label :for="'day-' + day.Id" class="by-checkable">{{ day.Naam }}</label>
				</div>
			</div>
		</template>
	</div>
</template>
